import { useEffect } from 'react';
import { PwaInstallPrompt } from '@/shared/components/feedback/PwaInstallPrompt';
import { ServiceWorkerUpdate } from '@/shared/components/feedback/ServiceWorkerUpdate';
import { useServiceWorker } from '@/shared/hooks/useServiceWorker';
import { monitoringService } from '@/shared/services';
import { usePwaStore } from '@/shared/stores/pwaStore';
import { AppProvider } from './providers/AppProvider';
import { AppRouter } from './routes/AppRouter';

function App() {
  const { needRefresh, offlineReady, updateServiceWorker } = useServiceWorker();
  const updateDismissed = usePwaStore((s) => s.updateDismissed);
  const setNeedRefresh = usePwaStore((s) => s.setNeedRefresh);
  const setUpdateDismissed = usePwaStore((s) => s.setUpdateDismissed);
  const setUpdateServiceWorker = usePwaStore((s) => s.setUpdateServiceWorker);

  // Sync service worker state into store for Header access
  useEffect(() => {
    setNeedRefresh(needRefresh);
  }, [needRefresh, setNeedRefresh]);

  useEffect(() => {
    setUpdateServiceWorker(updateServiceWorker);
  }, [updateServiceWorker, setUpdateServiceWorker]);

  // Track when update prompt is shown
  useEffect(() => {
    if (needRefresh && !updateDismissed) {
      monitoringService.trackPwaEvent('pwa.sw_update_prompted');
    }
  }, [needRefresh, updateDismissed]);

  const showAlert =
    (needRefresh && !updateDismissed) || (offlineReady && !needRefresh);

  return (
    <AppProvider>
      <AppRouter />

      {/* Service worker update notification */}
      {showAlert && (
        <ServiceWorkerUpdate
          needRefresh={needRefresh}
          offlineReady={offlineReady}
          onUpdate={() => {
            monitoringService.trackPwaEvent('pwa.sw_update_accepted');
            updateServiceWorker(true).catch((error) => {
              console.error('[App] Service worker update failed:', error);
            });
          }}
          onClose={() => {
            monitoringService.trackPwaEvent('pwa.sw_update_dismissed');
            setUpdateDismissed(true);
          }}
        />
      )}

      {/* PWA install prompt */}
      <PwaInstallPrompt />
    </AppProvider>
  );
}

export default App;
